<template>
  <div id="payment-methods">
    <SidebarLayout2 :breadcrumb="breadcrumb" pageTitle="Formas de pagamento">
      <!-- SIDEBAR -->
      <template #sidebar>
        <!-- NOME DO HOTEL -->
        <InfoPanel height="155" class="info-panel">
          <template #content>
            <Heading v-if="hotel" class="info-panel--title heading--size-2">
              {{ hotel.nome }}
            </Heading>
          </template>
        </InfoPanel>
        <SidebarBlock>
          <!-- MENU DOS HOTÉIS -->
          <PmwHotelNav
            :links="menuLinks"
            :hide="isHotelAbsolute ? ['diferenciais', 'banners'] : ['banners']"
            active="forma-pagamento"
            class="menu-nav"
          />

          <Heading element="h2" class="sidebar-title">
            Ações da página
          </Heading>
          <div class="sidebar-buttons">
            <PmwButton
              :hasIcon="true"
              variation="pmw-primary"
              class="sidebar-buttons--create"
              @click.stop.prevent="
                $router.push({ path: `${hotel.codigo}/novo` })
              "
            >
              Criar forma de pagamento
            </PmwButton>
            <PmwButton
              :disabled="disableEditButton"
              variation="pmw-primary"
              class="sidebar-buttons--edit"
              @click.stop.prevent="
                $router.push({
                  path: `${hotel.codigo}/editar/${selectedRows[0].codigo}`
                })
              "
            >
              Editar
            </PmwButton>
            <PmwButton
              :disabled="disabledDeleteButton"
              variation="red-100"
              class="sidebar-buttons--delete"
              @click.stop.prevent="
                deleteModal(selectedRows.codigo, null, null, 'lateral')
              "
            >
              Excluir
            </PmwButton>
          </div>
        </SidebarBlock>
      </template>

      <!-- CONTEÚDO -->
      <template #content>
        <span class="filters">
          <!-- BUSCA -->
          <SearchInput
            v-model="filterByName"
            placeholder="Buscar formas de pagamento"
            class="filters--search-input"
          />
        </span>
        <!-- TABELA -->
        <DataTable
          :cols="cols"
          :colsMinWidths="colsMinWidths"
          :sortable="true"
          :isLoading="loading"
          :rows="rows"
          :selectableRow="true"
          ref="dataTable"
          maxHeight="1080"
          class="datatable"
          @getSelectedRows="selectedRows = $event"
        >
          <!-- ITEM - NUMERO PARCELAS -->
          <template v-slot:numeroParcelas="data">
            <div v-if="data.rowDataObj.numeroParcelas === -1">
              N/A
            </div>
            <div v-else>{{ data.rowDataObj.numeroParcelas }}</div>
          </template>

          <!-- ITEM - VALOR MINIMO DAS PARCELAS -->
          <template v-slot:valorMinimoParcela="data">
            <div v-if="data.rowDataObj.valorMinimoParcela === -1">
              N/A
            </div>
            <div v-else>
              {{ getCurrencySymbol }} {{ data.rowDataObj.valorMinimoParcela }}
            </div>
          </template>

          <!-- ITEM - EXCLUSIVO TARIFA -->
          <template v-slot:exclusivoTarifa="data">
            {{ data.rowDataObj.exclusivoTarifa ? 'Não' : 'Sim' }}
          </template>

          <!-- ITEM - CENTRAL RESERVAS -->
          <template v-slot:exclusivoCentralReservas="data">
            <div
              v-if="
                data.rowDataObj.nome !== 'Pix' &&
                  data.rowDataObj.nome !== 'Boleto'
              "
            >
              N/A
            </div>

            <div v-else-if="data.rowDataObj.exclusivoCentralReservas">
              Sim
            </div>

            <div v-else-if="!data.rowDataObj.exclusivoCentralReservas">
              Não
            </div>
          </template>

          <!-- ITEM - EDITAR -->
          <template v-slot:editar="data">
            <button
              class="links--edit"
              @click.stop.prevent="
                $router.push({
                  path: `${hotel.codigo}/editar/${data.rowDataObj.codigo}`
                })
              "
            >
              Editar
            </button>
          </template>

          <!-- ITEM - EXCLUIR -->
          <template v-slot:excluir="data">
            <div>
              <button
                class="links--delete"
                @click.stop.prevent="
                  deleteModal(
                    data.rowDataObj.codigo,
                    data.rowDataObj.nome,
                    data.rowDataObj.exclusivoTarifa,
                    'listagem'
                  )
                "
              >
                Excluir
              </button>
            </div>
          </template>
        </DataTable>
        <!-- PAGINAÇÃO -->
        <PmwPagination
          :items="filterTable"
          :itemsPerPage="pagination.itemsPerPage"
          :currentPage="pagination.currentPage"
          :totalItems="filterTable.length"
          :itemsPerPageOptions="pagination.itemsPerPageOptions"
          class="pagination"
          @changePagination="changePagination"
        />

        <!-- MODAL DELEÇÃO -->
        <PmwAlertModal
          v-model="showDeleteModal"
          closeButton
          title="Excluir forma de pagamento"
          icon="pmw-trash-can"
          iconColor="red-100"
          cancelButtonColor="grey-90"
          confirmButtonColor="red-100"
          @alert-modal-cancel="cancelDisable()"
          @alert-modal-confirm="disablePayment()"
        >
          <template #text>
            {{ disableMessage }} <br />
            Tem certeza de que quer fazer isso?
          </template>
        </PmwAlertModal>

        <!-- MODAL DE AVISO -->
        <PmwAlertModal
          v-model="showWarningModal"
          closeButton
          title="Atenção"
          cancelButtonColor="blue-100"
          confirmButtonColor="blue-100"
          confirmButtonText="Ok, entendi"
          @alert-modal-cancel="showWarningModal = false"
          @alert-modal-confirm="showWarningModal = false"
        >
          <template #text>
            Na sua seleção existem algumas formas de pagamento padrão do hotel e
            outras não.
            <br />
            Por favor, verifique para deletá-las individualmente.
          </template>
        </PmwAlertModal>
      </template>
    </SidebarLayout2>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { capitalizeString } from '@/helpers/string'
import hotelCommonsMixin from '@/mixins/hotelCommonsMixin'

import PmwAlertModal from '@solucoes/components-lib-tmp/src/components/patterns/PmwAlertModal'
import PmwButton from '@solucoes/components-lib-tmp/src/components/elements/PmwButton'
import DataTable from '@solucoes/components-lib-tmp/src/components/patterns/DataTable'
import Heading from '@solucoes/components-lib-tmp/src/components/elements/Heading'
import PmwPagination from '@solucoes/components-lib-tmp/src/components/patterns/PmwPagination'
import SearchInput from '@solucoes/components-lib-tmp/src/components/elements/SearchInput'
import InfoPanel from '@solucoes/components-lib-tmp/src/components/patterns/InfoPanel'
import SidebarLayout2 from '@/layouts/SidebarLayout2'
import SidebarBlock from '@solucoes/components-lib-tmp/src/components/patterns/SidebarBlock'

export default {
  name: 'PaymentMethodsList',
  mixins: [hotelCommonsMixin],
  components: {
    PmwAlertModal,
    PmwButton,
    DataTable,
    Heading,
    PmwPagination,
    SearchInput,
    SidebarLayout2,
    InfoPanel,
    SidebarBlock
  },
  data() {
    return {
      breadcrumb: [],

      /** Colunas da tabela */
      cols: [
        {
          alias: 'Formas de pagamento',
          name: 'nome'
        },
        {
          alias: 'Parcelas',
          name: 'numeroParcelas'
        },
        {
          alias: 'Parcela mínima',
          name: 'valorMinimoParcela'
        },
        {
          alias: 'Padrão hotel',
          name: 'exclusivoTarifa'
        },
        {
          alias: 'Exclusivo central',
          name: 'exclusivoCentralReservas'
        },
        {
          alias: 'Ações',
          name: 'editar'
        },
        {
          name: 'excluir'
        }
      ],
      /** Largura mínima das colunas */
      colsMinWidths: {
        nome: '150px',
        email: '150px',
        status: '150px',
        editar: '77px',
        excluir: '77px'
      },
      /** Informações do hotel */
      hotel: null,
      /** V-model da busca */
      filterByName: '',
      /** Dados da paginação */
      pagination: {
        totalItems: 0,
        currentPage: 1,
        itemsPerPage: 10,
        startItemIndex: 1,
        lastItemIndex: 10,
        itemsPerPageOptions: [
          {
            text: '10',
            value: 10
          },
          {
            text: '25',
            value: 25
          },
          {
            text: '50',
            value: 50
          },
          {
            text: '75',
            value: 75
          },
          {
            text: '100',
            value: 100
          }
        ]
      },
      /** Linhas da tabela (dados) */
      rows: [],
      /** Armazena dados de retorno */
      allPayments: [],
      /** Loading da tabela */
      loading: true,
      /** Array das linhas selecionadas */
      selectedRows: [],
      /** Pagamento a ser deletado */
      paymentDelete: null,
      /** Exibição da modal de deleção */
      showDeleteModal: false,
      /** Exibição da modal de aviso */
      showWarningModal: false,
      /** Define se é desabilitado pela listagem ou barra lateral*/
      disableType: null,
      /** Mensagem do modal de deleção */
      disableMessage: null,
      isHotelAbsolute: false
    }
  },
  computed: {
    /** Verificação para desabilitar botão de excluir */
    disabledDeleteButton() {
      if (this.selectedRows.length >= 1) {
        return false
      }
      return true
    },

    /** Verificação para desabilitar botão de editar */
    disableEditButton() {
      if (this.selectedRows.length === 1) {
        return false
      }
      return true
    },

    /** Filtro da tela */
    filterTable() {
      /** Filtra pelo input */
      const results = this.allPayments.filter((data) => {
        return (
          data.nome.toLowerCase().indexOf(this.filterByName.toLowerCase()) > -1
        )
      })
      return results
    },

    ...mapGetters('hotel', ['getCurrencySymbol'])
  },

  async created() {
    /** Retorno de dados do hotel */
    await this.$hotel.get(this.hotelId).then((response) => {
      this.hotel = response.data
      this.isHotelAbsolute = response.data.tarifarioAbsoluto

      /** Define o valor do breadcrumb */
      this.breadcrumb = [
        {
          label: 'Letsbook'
        },
        {
          label: 'Hotéis',
          url: '/hoteis',
          isSpa: true /** se deve ser um link para o site novo ou antigo */
        },
        {
          label: capitalizeString(this.hotel.nome),
          url: `/hoteis/editar/${this.hotel.codigo}`,
          isSpa: true /** se deve ser um link para o site novo ou antigo */
        },
        {
          label: 'Formas de pagamento',
          url: `/hotel/formas-pagamento/${this.hotel.codigo}`,
          isSpa: true /** se deve ser um link para o site novo ou antigo */
        }
      ]
    })

    /** Faz a chamada da listagem de dados da tabela */
    await this.getAllPayments()
  },

  methods: {
    /** Retorna dados da listagem */
    async getAllPayments() {
      this.loading = true
      await this.$paymentMethods
        .listPaymentMethods(this.$route.params.id)
        .then((response) => {
          const results = response.data
          results.map(function(key, index) {
            /** Adiciona valor caso valorMinimoParcela seja nullo */
            if (key.valorMinimoParcela === null) {
              key.valorMinimoParcela = -1
            }

            /** Adiciona valor caso numeroParcelas seja nullo */
            if (
              key.nome === 'Pix' ||
              (key.nome === 'Boleto' && key.numeroParcelas === 1)
            ) {
              key.numeroParcelas = -1
            }
            results[index]['data'] = {
              nome: key.nome,
              numeroParcelas: key.numeroParcelas,
              valorMinimoParcela: key.valorMinimoParcela,
              exclusivoTarifa: key.exclusivoTarifa,
              exclusivoCentralReservas: key.exclusivoCentralReservas,
              id: key.codigo,
              codigo: key.codigo
            }
          })

          this.allPayments = results
        })
      this.loading = false
    },

    /** Desabilitar forma de pagamento */
    disablePayment() {
      if (this.disableType === 'listagem') {
        this.selectedRows = []
      }

      const DeletePayments = this.ifExists(
        this.selectedRows.length > 0
          ? this.selectedRows.map((item) => {
              return parseInt(item.id)
            })
          : [this.paymentDelete]
      )
      this.$paymentMethods
        .disablePaymentMethods(
          { codigos: DeletePayments },
          parseInt(this.hotelId)
        )
        .then(() => {
          this.$bus.$emit('show-alert-chip', {
            message: 'Forma de pagamento excluída com sucesso'
          })
          this.getAllPayments()
          this.resetPagination()
          this.selectedRows = []
          this.disableType = null
        })
        .catch(() => {
          this.$bus.$emit('show-alert-chip', {
            message: 'Erro ao excluir forma de pagamento'
          })
        })
    },

    /** Controle de deleção */
    deleteModal(paymentId, paymentName, defaultHotel, disableType) {
      this.disableType = disableType

      /** Verifica se a deleção vem da listagem ou menu lateral */
      if (disableType === 'listagem') {
        this.singleDisableRule(paymentName, defaultHotel)
      } else if (this.selectedRows.length === 1) {
        this.singleDisableRule(
          this.selectedRows[0].nome,
          this.selectedRows[0].exclusivoTarifa
        )
      } else if (disableType === 'lateral') {
        this.multipleDisableRule()
      }

      this.paymentDelete = paymentId
    },

    /** Caso seja deleção pelo botão da listagem */
    singleDisableRule(paymentName, defaultHotel) {
      /** Verifica se tem itens cadastrado com o mesmo nome */
      const results = this.allPayments.filter((data) => {
        return (
          data.nome
            .toLowerCase()
            .trim()
            .replace(/ +/g, '')
            .indexOf(
              paymentName
                .toLowerCase()
                .trim()
                .replace(/ +/g, '')
            ) > -1
        )
      })

      /** Verificações que modificam mensagem do modal de desabilitar */
      if (
        defaultHotel === true ||
        (defaultHotel === false && results.length <= 1)
      ) {
        /** Caso o não seja padrão hotel ou caso seja e não tenha outra formas de pagamento igual cadastrada */
        this.disableMessage =
          'Ao excluir uma forma de pagamento, ela não estará mais disponível para uso, essa é uma ação irreversível.'
        this.showDeleteModal = true
      } else if (defaultHotel === false && results.length > 1) {
        /** Caso que seja padrão de hotel e tenha outra forma de pagamento igual cadastrada */
        this.disableMessage =
          'Esta é uma forma de pagamento padrão do hotel, ao excluí-la, uma nova forma deste tipo vai se tornar padrão.'
        this.showDeleteModal = true
      }
    },

    /** Caso seja deleção pelo botão do menu lateral (Multiplas opções) */
    multipleDisableRule() {
      if (this.selectedRows.length > 1) {
        /** Armazena os valores do primeiro item do array */
        const firstItem = this.selectedRows[0]

        this.selectedRows.forEach((dados) => {
          /** Verifica se todos os itens selecionados são exclusivo ou não */
          const allItems = this.selectedRows.filter((data) => {
            return (
              data.exclusivoTarifa
                .toString()
                .indexOf(dados.exclusivoTarifa.toString()) > -1
            )
          })

          /** Verificações que modificam mensagem do modal de desabilitar */
          if (dados.exclusivoTarifa !== firstItem.exclusivoTarifa) {
            /** Caso os itens tenham o exclusivoTarifa diferente */
            return (this.showWarningModal = true)
          } else if (
            dados.exclusivoTarifa === firstItem.exclusivoTarifa &&
            dados.id !== firstItem.id &&
            allItems.length === this.selectedRows.length &&
            dados.exclusivoTarifa === false
          ) {
            /** Caso as formas selecionadas sejam padrão */
            this.disableMessage =
              'Estas são formas de pagamentos padrão do hotel, ao excluí-las, uma nova forma deste tipo vai se tornar padrão.'
            return (this.showDeleteModal = true)
          } else if (
            dados.exclusivoTarifa === firstItem.exclusivoTarifa &&
            dados.id !== firstItem.id &&
            dados.exclusivoTarifa === true
          ) {
            /** Caso as formas selecionadas não sejam padrão */
            this.disableMessage =
              'Ao excluir estas formas de pagamentos, elas não estarão mais disponível para uso, essa é uma ação irreversível.'
            return (this.showDeleteModal = true)
          }
        })
      }
    },

    /** Cancela deleção */
    cancelDisable() {
      this.disableType = null
      this.showDeleteModal = false
      this.paymentDelete = null
    },

    /** Verificar se dado existe */
    ifExists(element) {
      /** se for array */
      let result = null
      if (element && typeof element.value !== 'undefined') {
        result = element.value
        /** se for string */
      } else if (element !== '') {
        result = element
      }
      return result === true ? 1 : result
    },

    /** Usado para controle da paginação */
    changePagination(childData) {
      this.pagination.currentPage = childData.currentPage
      this.rows = childData.items
    },

    /** Reseta dados da paginação */
    resetPagination() {
      this.pagination.currentPage = 1
      this.pagination.startItemIndex = 1
      this.pagination.itemsPerPage = 25
      this.pagination.lastItemIndex = this.pagination.itemsPerPage
    }
  }
}
</script>

<style lang="scss" scoped>
.pagination {
  ::v-deep {
    p {
      margin: 0;
    }
    .select--button {
      font-weight: 500;
    }
  }
}
.links {
  &--edit {
    color: $pmw-blue;
    font-weight: font-weight('weight-medium');
    border: none;
    background-color: inherit;
  }
  &--delete {
    color: $pmw-error;
    font-weight: font-weight('weight-medium');
    border: none;
    background-color: inherit;
  }
}

::v-deep .content {
  /** Padding abaixo do título da página */
  .page-heading {
    padding-bottom: 24px;
  }
}
::v-deep .datable-grid-wrapper {
  .col {
    padding-left: 14px;
  }
}
.sidebar {
  .menu-nav {
    max-height: calc(100vh - 425px);
    overflow-y: scroll;
  }
  &-title {
    line-height: 21px;
    color: $pmw-gray-darkest;
    text-align: left;

    margin-bottom: 15px;
    margin-left: 15px;
  }
  &-buttons {
    display: flex;
    flex-direction: column;
    width: 215px;
    gap: 10px;
    margin: auto;
  }
}
.filters {
  display: flex;
  gap: 20px;
  margin-bottom: 25px;

  &--search-input {
    width: 232px;
  }
}

.datatable {
  ::v-deep {
    max-height: none;

    .pmw-col.pmw-th:nth-child(7),
    .pmw-col.pmw-th:nth-child(8) {
      max-width: 77px;
    }

    .pmw-col.pmw-th:nth-child(7),
    .pmw-col.pmw-th:nth-child(8) {
      border-right: none;
      pointer-events: none;
      .pmw-sort-icons {
        display: none;
      }
    }

    .pmw-col.pmw-td:nth-child(8),
    .pmw-col.pmw-td:nth-child(7) {
      justify-content: center;
      max-width: 77px;
    }
  }

  .action {
    &--item {
      font-size: font-size('size-small');
    }
  }
}

::v-deep .content--white_card {
  padding: {
    top: 40px;
    bottom: 40px;
  }
}
::v-deep .lb-breadcrumb--link:nth-child(2) {
  cursor: default;
}
</style>
